const NotFound = () => <div>یافت نشد</div>;

export default NotFound;
